import { useSelector } from 'react-redux';

const getCurrentManagerId = () => {
  if (typeof window === 'undefined' || !window.localStorage) return '';
  return window.localStorage.getItem('id') || '';
};

export const useAccountQueryContext = () => {
  const token = useSelector((state) => state.token);
  const tokenValue = token?.token;
  const managerId = getCurrentManagerId();

  return {
    tokenValue,
    managerId,
    accountKey: managerId || tokenValue || 'anonymous',
  };
};

export const accountScopedQueryOptions = {
  cacheTime: 0,
  staleTime: 0,
  refetchOnMount: 'always',
  refetchOnReconnect: true,
};
